import ViewIcon from "./view"

const Icon = ({
    className,
    width,
    height,
}: { 
    className: string;
    width: string;
    height: string;
}) => {
    return <div className={className}>
        <ViewIcon width={width} height={height} />
    </div>
}

export default Icon;